<template>
    <footer>
        <i class="icon c-quential lg"></i>
        <br />
        <a href="https://www.c-quential.nl" target="_blank">
            <strong>Planbord</strong> is een product van <strong>C-quential</strong>
        </a>
        &middot;
        <a href="https://c-quential.atlassian.net/wiki/spaces/PUB/pages/193134692/Privacyverklaring" target="_blank">Privacyverklaring</a>
        &middot;
        <a href="/licenses.html" target="_blank">Licenties van derden</a>
    </footer>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class AppFooter extends Vue {
    }
</script>

<style lang="scss" scoped>
    footer {
        --height: 4.9rem;
        background: linear-gradient(90deg, var(--cq-blue) 0%, var(--cq-azure) 60%, var(--cq-green) 100%);
        position: fixed;
        width: 100%;
        height: var(--height);
        right: calc(100vw - var(--app-footer-hidden-width));
        bottom: 0;
        transition: ease-out 0.25s;
        text-align: center;
        padding: 0.5rem;
        z-index: 200;

        &:hover {
            right: 0;
        }
    }

    .icon {
        background-color: var(--main-background-color);
    }

    footer, a:link, a:visited {
        color: var(--main-background-color);
        text-decoration: none;
    }

    a:link:hover, a:visited:hover {
        color: color-mix(in srgb, var(--main-background-color), #888);
    }
</style>
